const getSafePrice = (item) => {
  if (!item) return 0;

  if (typeof item.basePrice === 'number' && Number.isFinite(item.basePrice)) {
    return item.basePrice;
  }

  if (typeof item.price === 'number' && Number.isFinite(item.price)) {
    return item.price;
  }

  if (typeof item.price === 'string') {
    const parsed = Number.parseFloat(item.price.replace(/[^0-9.-]+/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

const getSafeCurrency = (item) => item?.currency || 'USD';

export const buildEcommerceItem = (item, quantity = 1) => ({
  item_id: String(item?.tebexPackageId || item?.id || ''),
  item_name: item?.title || item?.name || 'Unknown Product',
  price: getSafePrice(item),
  quantity
});

export const trackEcommerceEvent = (eventName, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, payload);
};

export const trackSocialClick = (platform, linkUrl) => {
  trackEcommerceEvent('social_click', {
    platform,
    link_url: linkUrl
  });
};

export const trackPageNotFound = () => {
  if (typeof window === 'undefined') return;

  trackEcommerceEvent('page_not_found', {
    page_location: window.location.href,
    page_referrer: document.referrer
  });
};

export const getSafeCurrencyFromItem = getSafeCurrency;
export const getSafePriceFromItem = getSafePrice;
